<div class="content">
  <div class="modal-header">
    <h4 class="modal-title full-width ">
      <span>{{ 'LABELS.SUCCESS' | translate}}</span>
    </h4>
  </div>
  <div class="modal-body">
    <div class="row">
      <div class="col">
        <div class="align-items-center text-center">
          <div>
            <i class="fa fa-check-circle custom-icon" [style.color]="'green'"></i>
          </div>
          <h3 class="mt-2">
            <span>{{ 'LABELS.PAYMENT_SUCCESSFUL' | translate }}</span>
          </h3>
          {{data?.message}}
        </div>
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <div class="button-list">
      <button type="button" class="btn btn-sm fis-btn" (click)="activeModal?.close(null)">{{ 'LABELS.CLOSE' | translate}}
      </button>
    </div>
  </div>
</div>
